<div class="component-container flex justify-start items-center gap-[20px]">
  <app-project-details-page-date-filter
    [defaultDateValue]="defaultDateValue"
    />
  <app-status-filter />
  <div>
    @if (selectedSortColumn) {
      <mat-form-field class="sort-dropdown">
        <mat-select
          (selectionChange)="onSortColumnChange($event)"
          [(value)]="selectedSortColumn"
          disableOptionCentering
          panelClass="rfi-sort-panel"
          >
          <mat-select-trigger>
            {{ selectedSortColumn ? 'Sort by: ' + selectedSortColumn : 'Sort: ' }}
          </mat-select-trigger>
          @for (column of sortByColumns; track column) {
            <mat-option [value]="column">
              {{ column | titlecase }}
            </mat-option>
          }
        </mat-select>
        <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix>close</mat-icon>
      </mat-form-field>
    }
    @if (!selectedSortColumn) {
      <div (click)="openSortDropdown($event)" class="sort-dropdown nosort">
        <div class="label text-type-8">Sort:</div>
        <mat-icon>sync_alt</mat-icon>
        <mat-form-field class="sr-sort-hidden">
          <mat-select
            #sortSelect
            (selectionChange)="onSortColumnChange($event)"
            [(value)]="selectedSortColumn"
            disableOptionCentering
            panelClass="rfi-sort-panel"
            >
            @for (column of sortByColumns; track column) {
              <mat-option [value]="column">
                {{ column | titlecase }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
  <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
    <form [formGroup]="form" class="flex-1 min-w-0">
      <div class="search w-full">
        <mat-icon (click)="search()" svgIcon="search"></mat-icon>
        <input
          class="search-input"
          formControlName="searchText"
          matInput
          placeholder="Search"
          />
        @if (form.controls.searchText.value) {
          <mat-icon
            (click)="close()"
            svgIcon="close"
          ></mat-icon>
        }
      </div>
    </form>
  </div>
</div>
